// src/utils/Loader.jsx
import { Box, CircularProgress, } from '@mui/material';
import { CenterContent } from './layouts';

// 1. إنشاء حركة النبض (Pulse Animation) للنص


const Loader = () => {
  return (

    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
      }}
    >
      {/* حاوية الحلقة المزدوجة */}
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        
        {/* الحلقة الخلفية (المسار الثابت والشفاف) */}
        <CircularProgress
          variant="determinate"
          value={100}
          size={24}
          thickness={4.5}
          sx={{
            // يتغير لون الخلفية بذكاء بناءً على الثيم (فاتح/داكن)
            color: (theme) => theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
          }}
        />

        {/* الحلقة الأمامية (الخط المتحرك) */}
        <CircularProgress
          variant="indeterminate"
          disableShrink
          size={24}
          thickness={4.5}
          sx={{
            color: 'warning.main',
            animationDuration: '1000ms', // سرعة دوران مريحة للعين
            position: 'absolute',
            left: 0,
            [`& .MuiCircularProgress-circle`]: {
              strokeLinecap: 'round', // حواف دائرية ناعمة
            },
          }}
        />
      </Box>
      
    </Box>

  );
};

export default Loader;